import { RECENSIO_LOGO } from "@/lib/constants";
import PrivacyPolicyLink from "@/components/PrivacyPolicy";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#141011] text-[#8A837C] mt-auto">
      <div className="max-w-3xl mx-auto px-6 py-10 text-center">
        <p className="font-display italic text-lg text-[#C5A059]/90">Ritrovo Rinascente</p>
        <p className="text-xs mt-1 tracking-wide">Via dei Mille, 240/242 — Messina · Tel. 090 6019495</p>
        <div className="mt-4">
          <PrivacyPolicyLink />
        </div>
        <div className="mt-6 pt-5 border-t border-[#C5A059]/15 flex items-center justify-center gap-2">
          <span className="text-[11px] tracking-widest uppercase">Powered by</span>
          <a
            data-testid="recensio-footer-link"
            href="https://recensio.eu"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center hover:opacity-80 transition-opacity"
          >
            <img src={RECENSIO_LOGO} alt="Recensio" className="h-5 w-auto" />
          </a>
        </div>
      </div>
    </footer>
  );
}
